// Test IDs for the Time2Cash marketing site.

export const HOME = {
    // Nav
    navLogo: 'nav-logo',
    navHome: 'nav-home',
    navFeatures: 'nav-features',
    navShops: 'nav-shops',
    navMarketplace: 'nav-marketplace',
    navSafety: 'nav-safety',
    navAmbassador: 'nav-ambassador',
    navAbout: 'nav-about',
    navContact: 'nav-contact',
    navFaq: 'nav-faq',
    navMore: 'nav-more',
    navDownloadCta: 'nav-download-cta',
    navMobileToggle: 'nav-mobile-toggle',
    navMobileMenu: 'nav-mobile-menu',

    // Hero
    heroDownloadAndroid: 'hero-download-android',
    heroDownloadIphone: 'hero-download-iphone',
    heroWatchDemo: 'hero-watch-demo',

    // Section CTAs
    ctaPostNeed: 'cta-post-need',
    ctaExploreJobs: 'cta-explore-jobs',
    ctaRegisterShop: 'cta-register-shop',
    ctaExploreMarketplace: 'cta-explore-marketplace',
    ctaSafetyLearnMore: 'cta-safety-learn-more',

    // Ambassador
    ambassadorForm: 'ambassador-form',
    ambassadorName: 'ambassador-name',
    ambassadorPhone: 'ambassador-phone',
    ambassadorCity: 'ambassador-city',
    ambassadorEmail: 'ambassador-email',
    ambassadorSubmit: 'ambassador-submit',
    ambassadorSuccess: 'ambassador-success',

    // FAQ
    faqAccordion: 'faq-accordion',
    faqViewAll: 'faq-view-all',

    // Download section
    downloadAndroid: 'download-android',
    downloadIphone: 'download-iphone',

    // Screenshots carousel
    screenshotCarousel: 'screenshot-carousel',
    screenshotPrev: 'screenshot-prev',
    screenshotNext: 'screenshot-next',

    // Contact
    contactEmailSupport: 'contact-email-support',
    contactEmailGeneral: 'contact-email-general',
    contactEmailPartners: 'contact-email-partners',

    // Footer
    footerRoot: 'footer-root',
};
